var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "500",
      "persistent": ""
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5 grey lighten-2"
  }, [_vm._v(" " + _vm._s(_vm.caseActionCaption) + " ")]), _c('v-card-text', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": [function (v) {
        return (v || '').length <= 40;
      }],
      "label": "Kurze Anweisung zur Aufgabe (max. 40 Zeichen)"
    },
    model: {
      value: _vm.caseText,
      callback: function ($$v) {
        _vm.caseText = $$v;
      },
      expression: "caseText"
    }
  })], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.acceptedDialog
    }
  }, [_vm._v(" Ok ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v(" Abbrechen ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }